import {AgentIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import type {FC} from 'react'

interface FindingsHeaderProps {
  displayedCount: number
  handleFix: () => void
}

export const FindingsHeader: FC<FindingsHeaderProps> = ({displayedCount, handleFix}) => (
  <div className="d-flex flex-items-center flex-justify-between tmp-mb-3">
    <h2 id="findings-heading" className="f4" tabIndex={-1}>
      Findings
    </h2>
    <Button size="small" leadingVisual={AgentIcon} onClick={handleFix} disabled={displayedCount === 0}>
      Fix with Copilot
    </Button>
  </div>
)
